import block_icons from "../icons/calltoaction";
import color_palette_list from "../gb-helper/color_palette";
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import IconPicker  from "./icon-picker/index"

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, RichText ,BlockControls,
    AlignmentToolbar,} = wp.blockEditor;
const { PanelBody, PanelRow, TextControl, SelectControl, RangeControl, Dashicon, ToggleControl,
    ColorPalette, ColorIndicator, Card, CardBody, Button, TabPanel, } = wp.components;

registerBlockType("blocksbakery/call-to-action", {
    title: __("Call To Action", "blocks-bakery"),
    description: __(
        "This block allows to create an attractive call-to-action with the help of trendy title, description, and one catchy button. It grabs the visitor’s attention for quick interaction and action.",
        "blocks-bakery"
    ),
    // common, formatting, layout, widgets, embed
    category: "blocks-bakery",
    icon: block_icons.callaction,
    keywords: [
        __("action", "blocks-bakery"),
        __("button", "blocks-bakery"),
        __("call to action", "blocks-bakery")
    ],
    supports: {
        html: false
    },
    attributes: {
        // editor setting
        heading_tag: {
            type: "html",
            default: "h3"
        },
        heading_val: {
            type: "string",
            default: "Call To Action"
        },
     
        paragraph_val: {
            type: "string",
            default: "Click here to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo."
        },
        btn_val: {
            type: "string",
            default: "Read More"
        },
        trail1: {
            type: "string"
        },

        trail: {
            type: "string"
        },
        // Layout
        btn_position: {
            type: "string",
            default: "Normal"
        },
        width_content: {
            type: "number",
            default: 100
        },
        open_window: {
            type: "boolean",
            default: false
        },
        v_alignment: {
            type: "string",
            default: "Top"
        },
        heading_size: {
            type: "number",
            
         
        },
        trail1: { 
            type: "string"
         },
        heading_weight: {
            type: "string",
            default:"regular"
        },
        heading_font_family: {
            type: "string",
            default:"ABeeZee"
        },
        heading_line_height: {
            type: "number",
            default:1.5
        },
        disp1: {
            type: "string",
            default: "none"
        },
        disp2: {
            type: "string",
            default: "flex"
        },
        heading_color: {
            type: "string",

        },
        description_size: {
            type: "number",
            default: 24
        },
        description_weight: {
            type: "string",
            default:"regular"
            
        },
        description_font_family: {
            type: "string",
            default:"ABeeZee"
        },
        description_line_height: {
            type: "number",
            default:1.5
        },
        desc_color: {
            type: "string",
  
        },
        windowOpen: {
            type: "string",
            default: "_self"
        },
        // spacing
        heading_bt_margin: {
            type: "number",
            default: 10
        },
        desc_bt_margin: {
            type: "number",
            default: 10
        },
        content_lf_margin: {
            type: "number",
        },
        // button
        btn_type: {
            type: "string",
            default: "Button"
        },
        url_icon: {
            type: "string",
            default: "#"
        },
        btn_size: {
            type: "number",
            default:15,
        },
        btn_weight: {
            type: "string",
            default:"regular",
        },
        btn_font_family: {
            type: "string",
            default:"ABeeZee"
        },
  
        position_icon: {
            type: "string",
            default: "after"
        },
        icon_spacing: {
            type: "number",
            default: 13
        },
        padding_lf_rh: {
            type: "number",
            default:17
        },
        padding_tb_bt: {
            type: "number",
            default: 13
        },
        border_btn: {
            type: "string",
            default: "Solid"
        },
        width_border: {
            type: "number",
            default: 2
        },
        radius_border: {
            type: "number"
        },
        txt_btn_color: {
            type: "string",
         
        },
        btn_bg_color: {
            type: "string",
        },
        border_color: {
            type: "string",
        },
        hover_txt_color: {
            type: "string"
        },
        hover_bg_color: {
            type: "string"
        },
        hover_border_color: {
            type: "string"
        },
        flex_save1: {
            type: "string",
            default: "flex"
        },
        flex_save2: {
            type: "string",
            default: "flex"
        },
        v_alignment_save: {
            type: "string",
            default: "flex-start"
        },
        call_btn_border: {
            type: "string",
        },
        call_btn_display: {
            type: "string",
            default: "flex"
        },
        before_save: {
            type: "string",
            default: "none"
        },
        after_save: {
            type: "string",
            default: "block"
        },
     
        text_alignment: {
            type: 'html',
            default: "left"
        },
        fontsize_px_em:{
            type: 'string',
            default: 'px'
        },
        fontsizedesc_px_em:{
            type: 'string',
            default: 'px'
        },
        fontsizebtn_px_em:{
            type: 'string',
            default: 'px'
        },
        maxwidthdesc:{
            type:"string",
            default:"70%"
        },
        margin_read_more:{
            type:'string',
            default:""
        },
        widthreadmore:{
            type:"string",
            default:"max-content"
        },
        px_he_inhegiht:{
            type:'string',
            default:'em',
        },
        px_em_desc_lg:{
            type:'string',
            default:'em'
        },
        icon_selector:
        {
            type:'string',
            default:'fas fa-window-close',
        },
        trial1:{
            type:"string",
        },
        trial:{
            type:"string"
        }
       
    },

    edit: (props) => {
        
        var index_heading = font_family_detailed.findIndex(x => x.family === props.attributes.heading_font_family);
        var heading_font_weight = font_family_detailed[index_heading].variants
        var heading_font_weight_list = []
        for (var i = 0; i < heading_font_weight.length; i++) {
            heading_font_weight_list.push({ label: heading_font_weight[i], value: heading_font_weight[i] })
        }


        var index_subheading = font_family_detailed.findIndex(x => x.family === props.attributes.description_font_family);
        var subheading_font_weight = font_family_detailed[index_subheading].variants
        var subheading_font_weight_list = []
        for (var i = 0; i < subheading_font_weight.length; i++) {
            subheading_font_weight_list.push({ label: subheading_font_weight[i], value: subheading_font_weight[i] })
        }

      
        var index_readmore = font_family_detailed.findIndex(x => x.family === props.attributes.btn_font_family);
        var readmore_font_weight = font_family_detailed[index_readmore].variants
        var readmore_font_weight_list = []
        for (var i = 0; i < readmore_font_weight.length; i++) {
            readmore_font_weight_list.push({ label: readmore_font_weight[i], value: readmore_font_weight[i] })
        }

        const px_desc_lineheight = () =>{
            var x = document.getElementById("px_desc_lineheight");
            var y = document.getElementById("em_desc_lineheight");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";

            props.setAttributes({px_em_desc_lg:"px"})
        }

        const em_desc_lineheight = () =>{
            var x = document.getElementById("px_desc_lineheight");
            var y = document.getElementById("em_desc_lineheight");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            
            props.setAttributes({px_em_desc_lg:"em"})
        }

        const position_icon_selector = (val) => {
        var x = document.getElementsByClassName("before");
            var y = document.getElementsByClassName("after");
            if (val === "before") {
                props.setAttributes({ before_save: "block" })
                props.setAttributes({ after_save: "none" })
            } else if (val === "after") {
                props.setAttributes({ before_save: "none" })
                props.setAttributes({ after_save: "block" })
            }
        };
        const btn_position = (new_val) => {
            var x = document.getElementsByClassName("btn_position")
            var y = document.getElementById("stack")

            if (new_val === "Normal") {
                props.setAttributes({ flex_save1: "flex" })
                y.style.display = "block"
            }
            else if (new_val === "Stack") {
                props.setAttributes({ flex_save1: "block" })
                y.style.display = "none"
            }
        }
        const v_alignment = (new_val) => {
            var x = document.getElementsByClassName("v_alignment")
            if (new_val === "Top") {
                props.setAttributes({ v_alignment_save: "flex-start" })
            }
            else if (new_val === "Middle") {
                props.setAttributes({ v_alignment_save: "center" })
            }
        }
        const inherit_toggle = (val) => {
            var inherit = document.getElementById("inherit")
            if (val === true) {
               
                props.setAttributes({ radius_border: 20 })
                props.setAttributes({ btn_bg_color: "#32373C" })
                props.setAttributes({ txt_btn_color: "white" })
                props.setAttributes({ border_color: "transparent" })
                props.setAttributes({ border_btn: "none" })

            } else if (val === false) {
               
                props.setAttributes({ radius_border: 2 })
                props.setAttributes({ btn_bg_color: "" })
                props.setAttributes({ txt_btn_color: "" })
                props.setAttributes({ border_btn: "solid" })
                props.setAttributes({ border_color: "" })


            }
        };
        const reset_heading = () => {
            props.setAttributes({heading_font_family:"ABeeZee"});
            props.setAttributes({heading_size:30});
            props.setAttributes({heading_weight:"regular"});
            props.setAttributes({heading_line_height:1.5});
        }
        const heading_typo = () => {
            var tp = document.getElementById("heading_body")
            if (tp.style.display === "none") {
                tp.style.display = "block"
            }
            else {
                tp.style.display = "none"
            }
        }
        const reset_desc = () => {
           
            props.setAttributes({description_font_family:"ABeeZee"});
            props.setAttributes({description_size:24});
            props.setAttributes({description_weight:"regular"});
            props.setAttributes({description_line_height:1.5});
        }
        const desc_typo = () => {
            var tp = document.getElementById("desc_body")
            if (tp.style.display === "none") {
                tp.style.display = "block"
            }
            else {
                tp.style.display = "none"
            }
        }
        const reset_btn = () => {
           
            props.setAttributes({btn_font_family:"ABeeZee"});
            props.setAttributes({btn_size:15});
            props.setAttributes({btn_weight:"regular"});
        }
        const btn_typo = () => {
            var tp = document.getElementById("btn_body")
            if (tp.style.display === "none") {
                tp.style.display = "block"
            }
            else {
                tp.style.display = "none"
            }
        }
    
        const px_heading = () => {
            var x = document.getElementById("px_heading");
            var y = document.getElementById("em_heading");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";
            props.setAttributes({ fontsize_px_em: 'px' })
            console.log("Changed1 px")
        }
        const em_heading = () => {
            var x = document.getElementById("px_heading");
            var y = document.getElementById("em_heading");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";
            props.setAttributes({ fontsize_px_em: 'em' })
            console.log("em")
        }

        const px_desc = () => {
            var x = document.getElementById("px_desc");
            var y = document.getElementById("em_desc");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";
            props.setAttributes({ fontsizedesc_px_em: 'px' })
        }
        const em_desc = () => {
            var x = document.getElementById("px_desc");
            var y = document.getElementById("em_desc");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";
            props.setAttributes({ fontsizedesc_px_em: 'em' })
        }

        const px_btn = () => {
            var x = document.getElementById("px_btn");
            var y = document.getElementById("em_btn");
            x.style.textDecoration = "underline";
           y.style.textDecoration = "none";
            props.setAttributes({ fontsizebtn_px_em: 'px' })
        }
        const em_btn = () => {
            var x = document.getElementById("px_btn");
            var y = document.getElementById("em_btn");
            x.style.textDecoration = "none";
           y.style.textDecoration = "underline";
            props.setAttributes({ fontsizebtn_px_em: 'em' })
        }
        const btn_type = (new_val) => {
            var x = document.getElementById("display1")
            var x1 = document.getElementById("display2")
            if (new_val === "None") {
                x.style.display = "none"
                x1.style.display = "none"
                props.setAttributes({ disp1: "none" })
                props.setAttributes({ disp2: "none" })
            }
            else if (new_val === "Text") {
                var inh = document.getElementById("inh");
                x.style.display="none"
                x.style.display = "block"
                x1.style.display = "none"
                props.setAttributes({ disp1: "flex" })
                props.setAttributes({ disp2: "none" })
            }
            else if (new_val === "Button") {
                x.style.display = "none"
                x1.style.display = "block"
                props.setAttributes({ disp1: "none" })
                props.setAttributes({ disp2: "flex" })
            }
        }
   
        const readmore_align_value= (val) => {
            if(val==="left"){
                props.setAttributes({margin_read_more:""})
                props.setAttributes({widthreadmore:"fit-content"})
            }
            if(val==="center"){
                props.setAttributes({margin_read_more:""})
                props.setAttributes({widthreadmore:""})
            }
            if(val==="right"){
                props.setAttributes({margin_read_more:"auto"})
                props.setAttributes({widthreadmore:"fit-content"})
            }
        }

        const px_headinglineheight = () =>{
            var x = document.getElementById("px_headinglineheight");
            var y = document.getElementById("em_headinglineheight");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";

            props.setAttributes({px_he_inhegiht:'px'})
        }
        const em_headinglineheight = () =>{
            var x = document.getElementById("px_headinglineheight");
            var y = document.getElementById("em_headinglineheight");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";

            props.setAttributes({px_he_inhegiht:'em'})
        }
        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__("Layout", "blocks-bakery")} initialOpen={true}>
                        <SelectControl
                            label={__("Button Position", "blocks_bakery")}
                            value={props.attributes.btn_position}
                            options={[
                                { label: "Normal", value: "Normal" },
                                { label: "Stack", value: "Stack" },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ btn_position: new_val })
                                btn_position(new_val)
                            }}
                        />
                        <div id="stack">
                        
                        <div className="range-controler" style={{display:"flex"}}>
                                       <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                label={__("Content Width (%)", "blocks_bakery")}
                                value={props.attributes.width_content}
                                onChange={(new_val) => {
                                    props.setAttributes({ width_content: new_val })
                                }}
                                min={0}
                                max={100}
                                initialPosition={100}
                               
                            />

                            </div>
                            <Button style={{
                                marginTop:26,
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                           
                                            props.setAttributes({width_content:100})
                                            }}> Reset 
                                        </Button>
                            </div>


                            <SelectControl
                                label={__("Vertical Alignment", "blocks_bakery")}
                                value={props.attributes.v_alignment}
                                options={[
                                    { label: "Top", value: "Top" },
                                    { label: "Middle", value: "Middle" },
                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ v_alignment: new_val })
                                    v_alignment(new_val)
                                }}
                            />
                        </div>
                    </PanelBody>
                    <PanelBody title={__("Content", "blocks-bakery")} initialOpen={false}>
                        <h2>Heading</h2>
                        <SelectControl
                            label={__("Tag", "blocks_bakery")}
                            value={props.attributes.heading_tag}
                            options={[
                                { label: "h1", value: "h1" },
                                { label: "h2", value: "h2" },
                                { label: "h3", value: "h3" },
                                { label: "h4", value: "h4" },
                                { label: "h5", value: "h5" },
                                { label: "h6", value: "h6" },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_tag: new_val })
                            }} />
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button style={{ padding: "0px" }}><span><Dashicon icon="image-rotate" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={reset_heading} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={heading_typo} /></span></Button>
                            </div>
                        </PanelRow>
                        {/* card body start */}
                        <Card id="heading_body" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_heading} id="px_heading" style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_heading}  id="em_heading" style={{fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    
                                    <div className="range-controler" style={{display:"flex"}}>
                                       <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                          
                                            beforeIcon="editor-textcolor"
                                            initialPosition={30}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            onChange={(new_val) => {
                                                props.setAttributes({ heading_size: new_val })
                                            }}
                                            value={props.attributes.heading_size}
                                        />
                                        </div>

                                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                           
                                            props.setAttributes({heading_size:30})
                                            }}> Reset 
                                        </Button>
                                    

                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_font_family: new_val })
                                        }}
                                        value={props.attributes.heading_font_family}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={heading_font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_weight: new_val })
                                        }}
                                        value={props.attributes.heading_weight}
                                    />

                                 <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_headinglineheight} id="px_headinglineheight" style={{  fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_headinglineheight}  id="em_headinglineheight" style={{textDecoration: "underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                       <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                    beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_line_height: new_val })
                                        }}
                                        value={props.attributes.heading_line_height}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                           
                                            props.setAttributes({heading_line_height:1.5})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p><span>{__("Color", "blocks-bakery")}
                            <ColorIndicator style={{ backgroundColor: props.attributes.heading_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.heading_color}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_color: new_val })
                            }}
                        />
                        <hr />
                        <h2>Description</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button style={{ padding: "0px" }}><span><Dashicon icon="image-rotate" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={reset_desc} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={desc_typo} /></span></Button>
                            </div>
                        </PanelRow>

                        {/* card body start */}
                        <Card id="desc_body" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_desc} id="px_desc" style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_desc} id="em_desc" style={{fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>

                                    <div className="range-controler " style={{display:"flex"}}>
                                        <div  style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            initialPosition={24}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            onChange={(new_val) => {
                                                props.setAttributes({ description_size: new_val })
                                            }}
                                            value={props.attributes.description_size}
                                        />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            //  var reset_heading=document.getElementsByClassName("reset_heading")[0];
                                            // reset_heading.style.fontSize=null;
                                            props.setAttributes({description_size:24})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_font_family: new_val })
                                        }}
                                        value={props.attributes.description_font_family}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={subheading_font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_weight: new_val })
                                        }}
                                        value={props.attributes.description_weight}
                                    />
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_desc_lineheight} id="px_desc_lineheight" style={{fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_desc_lineheight} id="em_desc_lineheight"  style={{ textDecoration: "underline", fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                    <div className="range-controler " style={{display:"flex"}}>
                                        <div  style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                      
                                        beforeIcon="editor-textcolor"
                                        initialPosition={1.5}
                                        step={0.1}
                                        min={0}
                                        max={100}
                                        onChange={(new_val) => {
                                            props.setAttributes({ description_line_height: new_val })
                                        }}
                                        value={props.attributes.description_line_height}
                                    />
                                    </div>
                                    <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            //  var reset_heading=document.getElementsByClassName("reset_heading")[0];
                                            // reset_heading.style.fontSize=null;
                                            props.setAttributes({description_line_height:1.5})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <p><span>{__("Color", "blocks-bakery")}
                            <ColorIndicator style={{ backgroundColor: props.attributes.desc_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.desc_color}
                            onChange={(new_val) => {
                                props.setAttributes({ desc_color: new_val })
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__("Button", "blocks-bakery")} initialOpen={false}>
                        <SelectControl
                            label={__("Type", "blocks_bakery")}
                            value={props.attributes.btn_type}
                            options={[
                                { label: "None", value: "None" },
                                { label: "Text", value: "Text" },
                                { label: "Button", value: "Button" },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ btn_type: new_val })
                                btn_type(new_val)
                            }}
                        />
                        <div id="display1" style={{ display: "none" }}>
                            <TextControl
                                label={__("Text", "blocks_bakery")}
                                value={props.attributes.btn_val}
                                onChange={(new_val) => {
                                    props.setAttributes({ btn_val: new_val })
                                }}
                            />
                            <PanelRow>
                                <p>Typography</p>
                                <div>
                                    <Button style={{ padding: "0px" }}><span><Dashicon icon="image-rotate" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={reset_btn} /></span></Button>
                                    <Button><span><Dashicon icon="admin-tools" style={{ fontSize: "15px", marginTop: "-5px" }} onClick={btn_typo} /></span></Button>
                                </div>
                            </PanelRow>
                            {/* card body start */}
                            <Card id="btn_body" style={{ display: "none" }}>
                                <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 46 }}>Font Size</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={px_btn} id="px_btn" style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={em_btn}  id="em_btn" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controller-main">
                                        <div className="textcoloring">
                                        </div>
                                        <div className="range-controler" style={{display:"flex"}}>
                                        <div style={{marginRight:"10px",width:"100%"}}>
                                            <RangeControl
                                                beforeIcon="editor-textcolor"
                                                initialPosition={15}
                                                min={0}
                                                max={100}
                                                step={0.1}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ btn_size: new_val })
                                                }}
                                                value={props.attributes.btn_size}
                                            />
                                            </div>
                                            <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            //  var reset_heading=document.getElementsByClassName("reset_heading")[0];
                                            // reset_heading.style.fontSize=null;
                                            props.setAttributes({btn_size:15})
                                            }}> Reset 
                                        </Button>
                                        </div>

                                        <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ btn_font_family: new_val })
                                        }}
                                        value={props.attributes.btn_font_family}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={readmore_font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ btn_weight: new_val })
                                        }}
                                        value={props.attributes.btn_weight}
                                    />
                                    </div>
                                </CardBody>
                            </Card>
                            <TextControl
                                label={__("Link", "blocks_bakery")}
                                value={props.attributes.url_icon}
                                onChange={(new_val) => {
                                    props.setAttributes({ url_icon: new_val })
                                }}
                            />
                         
                            <hr />
                            <h2>Button Icon</h2>
                            <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}
                       
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                          />
                            <SelectControl
                                label="Icon Position"
                                options={[
                                    { label: "Before Text", value: "before" },
                                    { label: "After Text", value: "after" },
                                ]}
                                value={props.attributes.position_icon}
                                onChange={(new_val) => {
                                    props.setAttributes({ position_icon: new_val })
                                    position_icon_selector(new_val)
                                }}
                            />
                              <div className="range-controler" style={{display:"flex"}}>
                            <div style={{marginRight:"10px",width:"100%"}}>
                            <RangeControl
                                label="Icon Spacing"
               
                                min={0}
                                max={50}
                                initialPosition={13}
                                value={props.attributes.icon_spacing}
                                onChange={(new_val) => {
                                    props.setAttributes({ icon_spacing: new_val })
                                }}
                            />
                            </div>
                            <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
                                    onClick={() => {
                                        props.setAttributes({icon_spacing:13})
                                    }}> Reset
                            </Button>
                            </div>
                            <TabPanel className="my-tab-panel"
                                activeClass="active-tab"
                                tabs={[
                                    {
                                        name:
                                            <ColorPalette
                                                value={props.attributes.txt_btn_color}
                                                colors={color_palette_list}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ txt_btn_color: new_val })
                                                }}
                                            />,
                                        value:
                                            <ColorIndicator colorValue={props.attributes.txt_btn_color} />,
                                        title: "Color",
                                        className: "tab-one",
                                    },
                                    {
                                        name: <ColorPalette
                                            colors={color_palette_list}
                                            value={props.attributes.hover_txt_color}
                                            onChange={(new_value) => {
                                                props.setAttributes({ hover_txt_color: new_value })
                                            }}
                                        />,
                                        value:
                                            <ColorIndicator colorValue={props.attributes.hover_txt_color} />,
                                        title: "Hover Color",
                                        className: "tab-two",
                                    },
                                ]}>
                                {
                                    (tab) =>

                                        <div className={props.className}>
                                            <p style={{ border: "1px solid" }}>{tab.button}</p>
                                            <p>Text {tab.title}{tab.value}</p>
                                            <p>{tab.name}</p>
                                            <hr />
                                        </div>
                                }
                            </TabPanel>
                            <hr />
                        </div>
                        <div id="display2" style={{ display: "block" }}>
                            <TextControl
                                label={__("Text", "blocks_bakery")}
                                value={props.attributes.btn_val}
                                onChange={(new_val) => {
                                    props.setAttributes({ btn_val: new_val })
                                }}
                            />
                            <div id="inh">
                            <ToggleControl
                                label="Inherit from Theme"
                                checked={props.attributes.inherit_toggle}
                                onChange={(new_val) => {
                                    props.setAttributes({ inherit_toggle: new_val })
                                    inherit_toggle(new_val)
                                }}
                            />
                            </div>
                            <div id="inherit">
                                <TextControl
                                    label={__("Link", "blocks_bakery")}
                                    value={props.attributes.url_icon}
                                    onChange={(new_val) => {
                                        props.setAttributes({ url_icon: new_val })
                                    }}
                                />
                                 <ToggleControl
                                label="open in new window"
                                initialPosition={false}
                                checked={props.attributes.open_window}
                                onChange={(new_val) => {
                                    props.setAttributes({ open_window: new_val })
                                    if (new_val === false) {
                                        props.setAttributes({ windowOpen: "_self" })
                                    } else if (new_val === true) {
                                        props.setAttributes({ windowOpen: "_blank" })
                                    }
                                }}
                            />
                                <h2>Button Icon</h2>
                                <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}
                       
                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                          />
                                <SelectControl
                                    label="Icon Position"
                                    options={[
                                        { label: "Before Text", value: "before" },
                                        { label: "After Text", value: "after" },
                                    ]}
                                    value={props.attributes.position_icon}
                                    onChange={(new_val) => {
                                        props.setAttributes({ position_icon: new_val })
                                        position_icon_selector(new_val)
                                    }}
                                />
                                <div className="range-controler" style={{display:"flex"}}>
<div style={{marginRight:"10px",width:"100%"}}>
                                <RangeControl
                                    label="Icon Spacing"
                         
                                    min={0}
                                    max={50}
                                    initialPosition={13}
                                    value={props.attributes.icon_spacing}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_spacing: new_val })
                                    }}
                                />
                                </div>
                                 <Button style={{
                               background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
                                 onClick={() => {
                               props.setAttributes({icon_spacing:13})
                              }}> Reset 
                                     </Button>
                                </div>
                                <h2>Button Padding (px)</h2>
                                <div>
                                    <svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.656-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.983h-14c-1.103 0-2 0.896-2 2v0.797h18v-0.797c0-1.103-0.896-2-2-2z"></path><path fill="#575E67" d="M3 19.031h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.104 0.896 2 2 2z"></path></svg>
                        <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        value={props.attributes.padding_tb_bt}
                                        onChange={(new_val) => {
                                            props.setAttributes({ padding_tb_bt: new_val })
                                        }}
                                        min={0}
                                        max={500}
                                       
                                        initialPosition={13}
                                    />
                                    </div>
                                    <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"}}
                                    onClick={() => {
                                        props.setAttributes({padding_tb_bt:13})
                                    }}> Reset 
                        </Button>
                        </div>
                                    <svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.016 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.103 0 2-0.896 2-2z"></path><path fill="#575E67" d="M0.968 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>
                                    <div className="range-controler" style={{display:"flex"}}>
                        <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        value={props.attributes.padding_lf_rh}
                                        onChange={(new_val) => {
                                            props.setAttributes({ padding_lf_rh: new_val })
                                        }}
                                        min={0}
                                        max={500}
                                   
                                        initialPosition={0}
                                    />
                                    </div>
                                    <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"}}
                                    onClick={() => {
                                        props.setAttributes({padding_lf_rh:17})
                                    }}> Reset 
                                     </Button>
                                    </div>
                                    <hr />
                                    <h3>Button Border</h3>
                                    <SelectControl
                                        label={__("Style", "blocks_bakery")}
                                        value={props.attributes.border_btn}
                                        options={[
                                            { label: "None", value: "None" },
                                            { label: "Solid", value: "Solid" },
                                            { label: "Double", value: "Double" },
                                            { label: "Dashed", value: "Dashed" },
                                            { label: "Dotted", value: "Dotted" }
                                        ]}
                                        onChange={(new_val) => {
                                            props.setAttributes({ border_btn: new_val })
                                        }}
                                    />
                                    <div className="range-controler" style={{display:"flex"}}>
<div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        label={__("Width", "blocks_bakery")}
                                        value={props.attributes.width_border}
                                        onChange={(new_val) => {
                                            props.setAttributes({ width_border: new_val })
                                        }}
                                        min={0}
                                        max={10}
                                        initialPosition={2}
                                       
                                    />
                                    </div>
                                    
                            <Button style={{
                                    background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba"}}
                                    onClick={() => {
                                        props.setAttributes({width_border:2})
                                    }}> Reset 
                        </Button>
                                    </div>
                                    <RangeControl
                                        label={__("Rounded Corner", "blocks_bakery")}
                                        value={props.attributes.radius_border}
                                        onChange={(new_val) => {
                                            props.setAttributes({ radius_border: new_val })
                                        }}
                                        min={0}
                                        max={100}
                                        initialPosition={0}
                                        allowReset={true}
                                    />
                                    <hr />
                                </div>
                                <TabPanel className="my-tab-panel"
                                    activeClass="active-tab"
                                    tabs={[
                                        {
                                            name: "Normal",
                                            title: "Text Color",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.txt_btn_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ txt_btn_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.txt_btn_color} />
                                        },
                                        {
                                            name: "Hover",
                                            title: "Text Hover",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.hover_txt_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ hover_txt_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.hover_txt_color} />
                                        },
                                    ]}>
                                    {
                                        (tab) => <div>
                                            <br />
                                            <p>{tab.value} {tab.title}</p>
                                            <p>{tab.className}</p>
                                        </div>
                                    }
                                </TabPanel>
                                <hr />
                                <TabPanel className="my-tab-panel"
                                    activeClass="active-tab"
                                    tabs={[
                                        {
                                            name: "Normal",
                                            title: "Background Color",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.btn_bg_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ btn_bg_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.btn_bg_color} />
                                        },
                                        {
                                            name: "Hover",
                                            title: "Background Hover",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.hover_bg_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ hover_bg_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.hover_bg_color} />
                                        },
                                    ]}>
                                    {
                                        (tab) => <div>
                                            <br />
                                            <p>{tab.value} {tab.title}</p>
                                            <p>{tab.className}</p>
                                        </div>
                                    }
                                </TabPanel>
                                <hr />
                                <TabPanel className="my-tab-panel"
                                    activeClass="active-tab"
                                    tabs={[
                                        {
                                            name: "Normal",
                                            title: "Border Color",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.border_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ border_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.border_color} />
                                        },
                                        {
                                            name: "Hover",
                                            title: "Border Hover",
                                            className: <ColorPalette
                                                colors={color_palette_list}
                                                value={props.attributes.hover_border_color}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ hover_border_color: new_val })
                                                }}
                                            />,
                                            value: <ColorIndicator colorValue={props.attributes.hover_border_color} />
                                        },
                                    ]}>
                                    {
                                        (tab) => <div>
                                            <br />
                                            <p>{tab.value} {tab.title}</p>
                                            <p>{tab.className}</p>
                                        </div>
                                    }
                                </TabPanel>
                            </div>
                        </div>
                    </PanelBody>
                    <PanelBody title={__("Spacing", "blocks-bakery")} initialOpen={false}>
                        
                    <div className="range-controler" style={{display:"flex"}}>
<div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label={__("Heading Bottom Margin", "blocks_bakery")}
                            value={props.attributes.heading_bt_margin}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_bt_margin: new_val })
                            }}
                            initialPosition={10}
                            min={0}
                            max={500}
                       
                        />
                        </div>
                        <Button style={{
            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
            onClick={() => {
                props.setAttributes({heading_bt_margin:10})
            }}> Reset 
                 </Button>   
                        </div>
                        <div className="range-controler" style={{display:"flex"}}>
              <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label={__("Description Bottom Margin", "blocks_bakery")}
                            value={props.attributes.desc_bt_margin}
                            onChange={(new_val) => {
                                props.setAttributes({ desc_bt_margin: new_val })
                            }}
                            min={0}
                            max={500}
                            initialPosition={10}
                          
                        />
                        </div>
                            <Button style={{
            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
            onClick={() => {
                props.setAttributes({desc_bt_margin:15})
            }}> Reset 
             </Button>
             
                  </div>
                  <div className="range-controler" style={{display:"flex"}}>
<div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            label={__("Content Left Margin", "blocks_bakery")}
                            value={props.attributes.content_lf_margin}
                            onChange={(new_val) => {
                                props.setAttributes({ content_lf_margin: new_val })
                            }}
                            min={0}
                            max={400}
                            initialPosition={0}
                        
                        />
                        </div>
            <Button style={{
            background: 'transparent', border: '1px solid #007cba', fontSize: '11px',width:"22%",height:"31px",color:"#007cba", marginTop:"25px"}}
            onClick={() => {
                props.setAttributes({content_lf_margin:0})
            }}> Reset 
             </Button>
                        </div>

                    </PanelBody>
                </InspectorControls>
                <div className="gb-call-to-action" >
                <BlockControls>
                        <AlignmentToolbar
                            value={props.attributes.text_alignment}
                            onChange={(new_val) => {
                                props.setAttributes({ text_alignment: new_val });
                                readmore_align_value(new_val);
                            }} 
                        />
                    </BlockControls>
                    <div className="gb-cta-wrapper" style={{ marginLeft: props.attributes.content_lf_margin }}>
                        <div style={{display:props.attributes.flex_save1}}>
                    <div className="gb-cta-btn-position btn_position" 
                    style={{maxWidth:"80%",width:"80%"}}
                    
                    >
                    

                       
                        <RichText
                            className="gb-cta-heading reset_heading"
                            style={{
                                textAlign: props.attributes.text_alignment,margin: "0px",
                                 fontSize: props.attributes.heading_size+props.attributes.fontsize_px_em,
                                  fontWeight: props.attributes.heading_weight,
                                fontFamily: props.attributes.heading_font_family,
                                 lineHeight: props.attributes.heading_line_height + props.attributes.px_he_inhegiht,
                                color: props.attributes.heading_color, marginBottom: props.attributes.heading_bt_margin
                            ,width: `${props.attributes.width_content}`+'%' ,
                            margin:"0px",
                     
                            }}
                            tagName={props.attributes.heading_tag}
                            value={props.attributes.heading_val}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_val: new_val })
                            }}
                        />
                     


                                <RichText
                                    className="gb-cta-btn-reset-description reset_desc"
                                    style={{
                                        textAlign: props.attributes.text_alignment,margin: "0px", 
                                        fontSize: props.attributes.description_size+props.attributes.fontsizedesc_px_em,
                                         fontWeight: props.attributes.description_weight,
                                        fontFamily: props.attributes.description_font_family,
                                        lineHeight: props.attributes.description_line_height + props.attributes.px_em_desc_lg,
                                        color: props.attributes.desc_color, marginBottom: props.attributes.desc_bt_margin
                                   ,margin:"0px",
                                   width: `${props.attributes.width_content}`+'%' ,
                                    }}
                                    tagName="p"
                                    value={props.attributes.paragraph_val}
                                    onChange={(new_val) => {
                                        props.setAttributes({ paragraph_val: new_val })
                                    }}
                                />
                        

                    </div>

                    <div className="bb-button-wrapper"
                    style={{width:"20%",marginLeft:10,alignSelf:props.attributes.v_alignment_save}}
                    >
                        
                    <div className="gb-cta-btn-aligment v_alignment" style={{ 
                               display:props.attributes.flex_save1,
                                 marginLeft:props.attributes.margin_read_more,
                                 justifyContent:props.attributes.text_alignment,
                                
                                 width:props.attributes.widthreadmore
                            }}>

                                {/* new normal icon */}
                                <div>
                                    <div
                                    style={{
                                            display: props.attributes.disp2,
                                            background: props.attributes.btn_bg_color, 
                                            borderStyle: props.attributes.border_btn,
                                             justifyContent: "center",
                                            paddingTop: props.attributes.padding_tb_bt, 
                                            paddingBottom: props.attributes.padding_tb_bt,
                                            paddingLeft: props.attributes.padding_lf_rh, 
                                            paddingRight: props.attributes.padding_lf_rh,
                                            borderWidth: props.attributes.width_border, 
                                            borderRadius: props.attributes.radius_border,
                                            borderColor: props.attributes.border_color
                                        }}>
                                        <a rel="noopener" href={props.attributes.url_icon} 
                                        target={props.attributes.windowOpen} 
                                        style={{
                                            textDecoration:"none",
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:"center",
                                            
                                            }}>
                                        <span className={props.attributes.icon_selector} style={{
                                         marginRight: props.attributes.icon_spacing,
                                         backgroundColor: props.attributes.trial1,
                                        color: props.attributes.txt_btn_color,
                                         display: props.attributes.before_save,
                                         marginTop: "7px",
                                        }} ></span>

                                       
                                        {/* stack button setting */}
                                        <div
                            
                                            className="gb-cta-btn-value btn_val"
                                            style={{
                                                width: "-webkit-fill-available",
                                                margin: "0px", 
                                                fontSize: props.attributes.btn_size+props.attributes.fontsizebtn_px_em,
                                                fontFamily: props.attributes.btn_font_family,
                                                backgroundColor: props.attributes.trial,
                                                fontWeight: props.attributes.btn_weight,
                                                color: props.attributes.txt_btn_color, 
                                                textAlign:'center',
                                             
                                            }}
                                        >{props.attributes.btn_val}</div>
                                        <span   className={props.attributes.icon_selector}  style={{
                                            display: props.attributes.after_save,
                                             marginLeft: props.attributes.icon_spacing, 
                                             backgroundColor: props.attributes.trial1,
                                            color: props.attributes.txt_btn_color, 
                                            
                                        }} ></span>
                                        </a>
                                    </div>

                                    <div
                                     style={{
                                            display: props.attributes.disp1, 
                                            justifyContent: "center",
                                            paddingTop: props.attributes.padding_tb_bt,
                                             paddingBottom: props.attributes.padding_tb_bt,
                                            paddingLeft: props.attributes.padding_lf_rh,
                                             paddingRight: props.attributes.padding_lf_rh,

                                        }}>
                                        <a rel="noopener" href={props.attributes.url_icon}
                                         target={props.attributes.windowOpen}
                                         style={{textDecoration:"none",display:"flex"}}>
                                        <span className="gb-cta-btn-icon icon"  
                                        className={props.attributes.icon_selector}  style={{
                                            marginRight: props.attributes.icon_spacing,
                                             backgroundColor: props.attributes.trial1,
                                            color: props.attributes.txt_btn_color,
                                             display: props.attributes.before_save
                                        }} ></span>
                                        <div
                               
                                            className="gb-cta-btn-value btn_val"
                                            style={{
                                                width:"-webkit-fill-available",
                                                margin: "0px", fontSize: props.attributes.btn_size+props.attributes.fontsizebtn_px_em, fontFamily: props.attributes.btn_font_family,
                                                backgroundColor: props.attributes.trial,
                                                fontWeight: props.attributes.btn_weight, 
                                                color: props.attributes.txt_btn_color,
                                                 textAlign:'center',
                                               
                                            }}
                                        >{props.attributes.btn_val}
                                        
                                        
                                        </div>
                                        <span className="gb-cta-btn-icon  icon" className={props.attributes.icon_selector}  style={{
                                            display: props.attributes.after_save, 
                                            marginLeft: props.attributes.icon_spacing, 
                                            backgroundColor: props.attributes.trial1,
                                          color: props.attributes.txt_btn_color
                                        }} ></span>
                                        </a>
                                    </div>
                                </div>

                                
                            </div>
                    </div>


                        </div>



                        </div>

                     



                            
                    </div>
            </React.Fragment>
        )
    },

    save: (props) => {
        return (
            <React.Fragment>
         <div className="gb-call-to-action" >
                    <div className="gb-cta-wrapper" style={{ marginLeft: props.attributes.content_lf_margin }}>
                        <div style={{display:props.attributes.flex_save1}}>
                    <div className="gb-cta-btn-position btn_position" 
                    style={{maxWidth:"80%",width:"80%"}}
                    
                    >
                    

                       
                        <RichText.Content
                            className="gb-cta-heading reset_heading"
                            style={{
                                textAlign: props.attributes.text_alignment,margin: "0px",
                                 fontSize: props.attributes.heading_size+props.attributes.fontsize_px_em,
                                  fontWeight: props.attributes.heading_weight,
                                fontFamily: props.attributes.heading_font_family,
                                 lineHeight: props.attributes.heading_line_height + props.attributes.px_he_inhegiht,
                                color: props.attributes.heading_color, marginBottom: props.attributes.heading_bt_margin
                            ,width: `${props.attributes.width_content}`+'%' ,
                            margin:"0px",
                     
                            }}
                            tagName={props.attributes.heading_tag}
                            value={props.attributes.heading_val}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_val: new_val })
                            }}
                        />
                     


                                <RichText.Content
                                    className="gb-cta-btn-reset-description reset_desc"
                                    style={{
                                        textAlign: props.attributes.text_alignment,margin: "0px", 
                                        fontSize: props.attributes.description_size+props.attributes.fontsizedesc_px_em,
                                         fontWeight: props.attributes.description_weight,
                                        fontFamily: props.attributes.description_font_family,
                                        lineHeight: props.attributes.description_line_height + props.attributes.px_em_desc_lg,
                                        color: props.attributes.desc_color, marginBottom: props.attributes.desc_bt_margin
                                   ,margin:"0px",
                                   width: `${props.attributes.width_content}`+'%' ,
                                    }}
                                    tagName="p"
                                    value={props.attributes.paragraph_val}
                                    onChange={(new_val) => {
                                        props.setAttributes({ paragraph_val: new_val })
                                    }}
                                />
                        

                    </div>

                    <div className="bb-button-wrapper"
                    style={{width:"20%",marginLeft:10,alignSelf:props.attributes.v_alignment_save}}
                    >
                        
                    <div className="gb-cta-btn-aligment v_alignment" style={{ 
                               display:props.attributes.flex_save1,
                                 marginLeft:props.attributes.margin_read_more,
                                 justifyContent:props.attributes.text_alignment,
                                
                                 width:props.attributes.widthreadmore
                            }}>

                                {/* new normal icon */}
                                <div>
                                    <div
                                    style={{
                                            display: props.attributes.disp2,
                                            background: props.attributes.btn_bg_color, 
                                            borderStyle: props.attributes.border_btn,
                                             justifyContent: "center",
                                            paddingTop: props.attributes.padding_tb_bt, 
                                            paddingBottom: props.attributes.padding_tb_bt,
                                            paddingLeft: props.attributes.padding_lf_rh, 
                                            paddingRight: props.attributes.padding_lf_rh,
                                            borderWidth: props.attributes.width_border, 
                                            borderRadius: props.attributes.radius_border,
                                            borderColor: props.attributes.border_color
                                        }}>
                                        <a rel="noopener" href={props.attributes.url_icon} 
                                        target={props.attributes.windowOpen} 
                                        style={{
                                            textDecoration:"none",
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:"center",
                                            
                                            }}>
                                        <span className={props.attributes.icon_selector} style={{
                                         marginRight: props.attributes.icon_spacing,
                                         backgroundColor: props.attributes.trial1,
                                        color: props.attributes.txt_btn_color,
                                         display: props.attributes.before_save,
                                         marginTop: "7px",
                                        }} ></span>

                                       
                                        {/* stack button setting */}
                                        <div
                            
                                            className="gb-cta-btn-value btn_val"
                                            style={{
                                                width: "-webkit-fill-available",
                                                margin: "0px", 
                                                fontSize: props.attributes.btn_size+props.attributes.fontsizebtn_px_em,
                                                fontFamily: props.attributes.btn_font_family,
                                                backgroundColor: props.attributes.trial,
                                                fontWeight: props.attributes.btn_weight,
                                                color: props.attributes.txt_btn_color, 
                                                textAlign:'center',
                                             
                                            }}
                                        >{props.attributes.btn_val}</div>
                                        <span   className={props.attributes.icon_selector}  style={{
                                            display: props.attributes.after_save,
                                             marginLeft: props.attributes.icon_spacing, 
                                             backgroundColor: props.attributes.trial1,
                                            color: props.attributes.txt_btn_color, 
                                            
                                        }} ></span>
                                        </a>
                                    </div>

                                    <div
                                     style={{
                                            display: props.attributes.disp1, 
                                            justifyContent: "center",
                                            paddingTop: props.attributes.padding_tb_bt,
                                             paddingBottom: props.attributes.padding_tb_bt,
                                            paddingLeft: props.attributes.padding_lf_rh,
                                             paddingRight: props.attributes.padding_lf_rh,

                                        }}>
                                        <a rel="noopener" href={props.attributes.url_icon}
                                         target={props.attributes.windowOpen}
                                         style={{textDecoration:"none",display:"flex"}}>
                                        <span className="gb-cta-btn-icon icon"  
                                        className={props.attributes.icon_selector}  style={{
                                            marginRight: props.attributes.icon_spacing,
                                             backgroundColor: props.attributes.trial1,
                                            color: props.attributes.txt_btn_color,
                                             display: props.attributes.before_save
                                        }} ></span>
                                        <div
                               
                                            className="gb-cta-btn-value btn_val"
                                            style={{
                                                width:"-webkit-fill-available",
                                                margin: "0px", fontSize: props.attributes.btn_size+props.attributes.fontsizebtn_px_em, fontFamily: props.attributes.btn_font_family,
                                                backgroundColor: props.attributes.trial,
                                                fontWeight: props.attributes.btn_weight, 
                                                color: props.attributes.txt_btn_color,
                                                 textAlign:'center',
                                               
                                            }}
                                        >{props.attributes.btn_val}
                                        
                                        
                                        </div>
                                        <span className="gb-cta-btn-icon  icon" className={props.attributes.icon_selector}  style={{
                                            display: props.attributes.after_save, 
                                            marginLeft: props.attributes.icon_spacing, 
                                            backgroundColor: props.attributes.trial1,
                                          color: props.attributes.txt_btn_color
                                        }} ></span>
                                        </a>
                                    </div>
                                </div>

                                
                            </div>
                    </div>


                        </div>



                        </div>

                     



                            
                    </div>
            </React.Fragment>
        )
    }
})